export const RENTAL_PERIODS = [
  "night",
  "week",
  "month",
  "quarter",
  "semi_annual",
  "annual",
] as const;

export type RentalPeriod = (typeof RENTAL_PERIODS)[number];

export const RENTAL_PERIOD_LABELS: Record<RentalPeriod, string> = {
  night: "Nacht",
  week: "Woche",
  month: "Monat",
  quarter: "Quartal",
  semi_annual: "Halbjahr",
  annual: "Jahr",
};

export const RENTAL_PERIOD_PRICE_LABELS: Record<RentalPeriod, string> = {
  night: "pro Nacht",
  week: "pro Woche",
  month: "pro Monat",
  quarter: "pro Quartal",
  semi_annual: "pro Halbjahr",
  annual: "pro Jahr",
};

export function normalizeRentalPeriod(value: string | null | undefined): RentalPeriod {
  if (value && (RENTAL_PERIODS as readonly string[]).includes(value)) {
    return value as RentalPeriod;
  }
  return "night";
}

export function rentalPeriodLabel(value: string | null | undefined): string {
  return RENTAL_PERIOD_LABELS[normalizeRentalPeriod(value)];
}

export function rentalPeriodPriceLabel(value: string | null | undefined): string {
  return RENTAL_PERIOD_PRICE_LABELS[normalizeRentalPeriod(value)];
}
